<template>
  <div class="container main-content content--solution-assets">
    <h2>Assets</h2>
    <div class="row boxes-row">
      <div class="col-lg-4" v-for="(box,i) in boxes" :key="i">
        <div class="box">
          <span class="box-title">
            <img :src="`/web/files/icon-${getAssetIconName(box)}.svg`">
            {{box.title}}
          </span>
          <p>{{box.description}}</p>
          <div class="box-bottom">
<!--            <span :class="['box-type', {'box-type&#45;&#45;video': box.type === 'VIDEO'}]" v-if="box.type !== 'LINK'">{{box.type}}</span>-->
<!--            <span class="box-size" v-if="box.type === 'FILE'">{{formatBytes(box.size, 1)}}</span>-->
            <template v-if="box.type === 'LINK'">
              <a target="_blank" class="link-icon--alt" :href="box.value">
                <span>Open</span> <i class="icon-external2"></i>
              </a>
            </template>
            <template v-else-if="box.type === 'VIDEO'">
              <a class="link-icon--alt" @click="openModal = true; videoLink = box.value">
                  <span>View</span> <i class="icon-video"></i>
              </a>
            </template>
            <template v-else>
              <a class="link-icon--alt" target="_blank" :href="`https://engage.edge.capgemini.com/api/filepreview/${box.value}`">
                <span>Preview</span> <i class="icon-external2"></i>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <SolutionVideoPopup v-if="openModal" :video-link="videoLink" @close="openModal = false; videoLink = null"></SolutionVideoPopup>
  </div>
</template>

<script>
import {formatBytes} from "@/helpers/formatBytes";
import SolutionVideoPopup from "@/components/solutions/SolutionVideoPopup";

export default {
  name: "SolutionAssets",
  components: {SolutionVideoPopup},
  data() {
    return {
      openModal: false,
      videoLink: ''
    }
  },
  computed: {
    boxes() {
      return this.$store.getters.solutionAssets
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', this.$store.getters.solution.headline + ' | ' + 'Assets']);
    window._paq.push(['trackPageView']);
  },
  methods: {
    getAssetIconName(box) {
      switch (box.type) {
        case 'FILE':
          if(box.fileType.includes('pdf')) {
            return 'pdf'
          }
          return 'doc'
       case 'VIDEO':
         return 'video'
       case 'LINK':
          return 'link'
      }
    },
    formatBytes: formatBytes
  },
}
</script>
